module.exports = __webpack_public_path__ + "static/media/iconfinder_medal_1118195.a73d6254.svg";